"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSVG = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _BaseSVG(_ref, ref) {
  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      ui = _ref.ui;
  var foregroundColor, backgroundColor;

  switch (ui) {
    case 'blue':
      backgroundColor = 'transparent';
      foregroundColor = _colors.colors.blue500;
      break;

    case 'dark':
      backgroundColor = _colors.colors.darkCool500;
      foregroundColor = _colors.colors.white;
      break;

    case 'light':
      backgroundColor = 'transparent';
      foregroundColor = _colors.colors.secondary;
      break;

    default:
      backgroundColor = 'transparent';
      foregroundColor = color;
  }

  var height, padding, width;

  switch (size) {
    case 'small':
      height = 12;
      padding = '0';
      width = 12;
      break;

    case 'medium':
      height = 16;
      padding = '0';
      width = 16;
      break;

    default:
      height = 24;
      padding = '0';
      width = 24;
  }

  return (/*#__PURE__*/_react.default.createElement("svg", {
      fill: "none",
      height: height,
      ref: ref,
      style: _objectSpread({
        backgroundColor: backgroundColor,
        display: 'inline-block',
        padding: padding
      }, style),
      viewBox: "0 0 16 16",
      width: width,
      xmlns: "http://www.w3.org/2000/svg"
    }, children(foregroundColor))
  );
}

_BaseSVG.displayName = 'BaseSVG';

var BaseSVG = _react.default.forwardRef(_BaseSVG);

exports.BaseSVG = BaseSVG;
BaseSVG.defaultProps = {
  color: 'white',
  size: 'large',
  style: {}
};
BaseSVG.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  style: _propTypes.default.object,
  ui: _propTypes.default.oneOf(['light', 'dark', 'blue'])
};